import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import ComponentGroupsService from '../../services/ComponentGroupsService';


const initialState = {
    data: {},
    columnConfig: [],
    status: "idle",

};

export const fetchComponentGroups = createAsyncThunk('componentGroups', async () => {
    const response = await ComponentGroupsService.getComponentGroups();
    return response;
});


export const ComponentGroupsSlice = createSlice({
    name: 'componentGroups',
    initialState,
    reducers: {
        addComponentGroupColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToComponentGroupColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchComponentGroups.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchComponentGroups.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
                console.log(state)
            })
    }
});

export const selectComponentGroup = (state) => {
    console.log(state)
    return state.componentGroups.data;
}

export const { addComponentGroupColumnConfig, addColumnToComponentGroupColumnConfig } =
    ComponentGroupsSlice.actions;


export const selectComponentGroupsColumnConfig = (state) =>
    state.componentGroups.columnConfig;

export default ComponentGroupsSlice.reducer;